export const GET_USERS_MERCHANT_APPLICATION ="GET_USERS_MERCHANT_APPLICATION"
export const GET_USERS_MERCHANT_APPLICATION_SUCCESS="GET_USERS_MERCHANT_APPLICATION_SUCCESS"
export const GET_USERS_MERCHANT_APPLICATION_FAIL = "GET_USERS_MERCHANT_APPLICATION_FAIL"

export const GET_USER_CAN_MAKE_APPLICATION ="GET_USER_CAN_MAKE_APPLICATION"
export const GET_USER_CAN_MAKE_APPLICATION_SUCCESS= "GET_USER_CAN_MAKE_APPLICATION_SUCCESS"
export const GET_USER_CAN_MAKE_APPLICATION_FAIL = "GET_USER_CAN_MAKE_APPLICATION_FAIL"

export const GET_USER_CAN_APPROVE_AGREEMENT ="GET_USER_CAN_APPROVE_AGREEMENT"
export const GET_USER_CAN_APPROVE_AGREEMENT_SUCCESS= "GET_USER_CAN_APPROVE_AGREEMENT_SUCCESS"
export const GET_USER_CAN_APPROVE_AGREEMENT_FAIL = "GET_USER_CAN_APPROVE_AGREEMENT_FAIL"

export const ADD_MERCHANT_APPLICATION = "ADD_MERCHANT_APPLICATION"
export const ADD_MERCHANT_APPLICATION_SUCCESS = "ADD_MERCHANT_APPLICATION_SUCCESS"
export const ADD_MERCHANT_APPLICATION_FAIL = "ADD_MERCHANT_APPLICATION_FAIL"

export const APPROVE_MERCHANT_AGREEMENT = "APPROVE_MERCHANT_AGREEMENT"
export const APPROVE_MERCHANT_AGREEMENT_SUCCESS ="APPROVE_MERCHANT_AGREEMENT_SUCCESS"
export const APPROVE_MERCHANT_AGREEMENT_FAIL = "APPROVE_MERCHANT_AGREEMENT_FAIL"

export const UPLOAD_MERCHANT_FILE = "UPLOAD_MERCHANT_FILE"
export const UPLOAD_MERCHANT_FILE_SUCCESS = "UPLOAD_MERCHANT_FILE_SUCCESS"
export const UPLOAD_MERCHANT_FILE_FAIL = "UPLOAD_MERCHANT_FILE_FAIL"

export const UPLOAD_MERCHANT_FILE_LIST = "UPLOAD_MERCHANT_FILE_LIST"
export const UPLOAD_MERCHANT_FILE_LIST_SUCCESS = "UPLOAD_MERCHANT_FILE_LIST_SUCCESS"
export const UPLOAD_MERCHANT_FILE_LIST_FAIL = "UPLOAD_MERCHANT_FILE_LIST_FAIL"

export const DELETE_MERCHANT_FILE = "DELETE_MERCHANT_FILE"
export const DELETE_MERCHANT_FILE_SUCCESS = "DELETE_MERCHANT_FILE_SUCCESS"
export const DELETE_MERCHANT_FILE_FAIL = "DELETE_MERCHANT_FILE_FAIL"

export const GET_MERCHANT_APPLICATION_DOCUMENT ="GET_MERCHANT_APPLICATION_DOCUMENT"
export const GET_MERCHANT_APPLICATION_DOCUMENT_SUCCESS="GET_MERCHANT_APPLICATION_DOCUMENT_SUCCESS"
export const GET_MERCHANT_APPLICATION_DOCUMENT_FAIL = "GET_MERCHANT_APPLICATION_DOCUMENT_FAIL"

export const GET_MERCHANT_APPLICATION_DOCUMENT_FILE ="GET_MERCHANT_APPLICATION_DOCUMENT_FILE"
export const GET_MERCHANT_APPLICATION_DOCUMENT_FILE_SUCCESS="GET_MERCHANT_APPLICATION_DOCUMENT_FILE_SUCCESS"
export const GET_MERCHANT_APPLICATION_DOCUMENT_FILE_FAIL = "GET_MERCHANT_APPLICATION_DOCUMENT_FILE_FAIL"


export const MERCHANT_APPLICATION_API_ERROR = "API_ERROR"

